import { Stack, Typography } from '@mui/material';
import type {
  Snapshot,
  BackupVault,
  InventoryResource,
} from '@repo/api-gw-sdk';

import { Panels } from '@/components/panels/panels';
import { useViewParameters } from '@/contexts/navigation';
import { useWorkspace } from '@/contexts/useWorkspace';

import type { MutateSnapshots } from './eonSnapshotsTab';
import type { RestoreWizardFactory } from './restoreWizardFactory';
import { SnapshotRow } from './snapshotRow';

export const SnapshotsRows = ({
  snapshots,
  vaults,
  selectedSnapshot,
  setSelectedSnapshot,
  entity,
  restoreWizardFactory,
  mutateSnapshots,
}: {
  snapshots: Snapshot[];
  vaults: BackupVault[];
  selectedSnapshot: string;
  setSelectedSnapshot: (snapshotId: string) => void;
  entity: InventoryResource;
  restoreWizardFactory: RestoreWizardFactory | undefined;
  mutateSnapshots: MutateSnapshots;
}) => {
  const { rightPanel } = useWorkspace();
  const { removeParam } = useViewParameters();

  if (snapshots.length === 0) {
    return <SnapshotsEmptyState />;
  }

  const onClose = () => {
    rightPanel.setIsOpen(false);
    removeParam('id');
  };

  const onBack = () => {
    rightPanel.setComponent({
      panel: Panels.InventoryInstance,
      props: {
        id: entity.id,
        onClose,
        initialTab: 'eon-snapshots',
      },
    });
  };

  return snapshots.map((snap) => {
    return (
      <SnapshotRow
        key={snap.id}
        snap={snap}
        vault={vaults.find((v) => v.id === snap.vaultId)}
        isSelected={selectedSnapshot === snap.id}
        onSelect={() => setSelectedSnapshot(snap.id)}
        resource={entity}
        snapshotSelection={snapshots.length > 1}
        mutateSnapshots={mutateSnapshots}
        onRestore={
          restoreWizardFactory
            ? () => {
                const config = restoreWizardFactory({
                  snapshot: snap,
                  resource: entity,
                  onClose,
                  onBack,
                });
                rightPanel.setComponent(config);
              }
            : undefined
        }
      />
    );
  });
};

export const SnapshotsEmptyState = () => {
  return (
    <Stack
      height='100%'
      alignItems='center'
      justifyContent='center'
      gap='8px'
      paddingY='24px'
    >
      <Typography variant='body1' width='260px' textAlign='center'>
        {`No snapshots in this time slot yet.`}
      </Typography>
    </Stack>
  );
};
